import type { SVGProps } from 'react';
const SvgIconPayment = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M7.17 4.754a2.13 2.13 0 0 0-2.105 1.998 1.877 1.877 0 0 0 1.896 1.997h2a.47.47 0 0 1 .474.5.533.533 0 0 1-.527.499h-3.25a.8.8 0 0 0-.789.749.704.704 0 0 0 .71.749h1.5l-.038.749a.47.47 0 0 0 .473.499h.5a.533.533 0 0 0 .527-.5l.039-.748h.25a2.13 2.13 0 0 0 2.105-1.998 1.88 1.88 0 0 0-1.896-1.997h-2a.47.47 0 0 1-.474-.5.533.533 0 0 1 .527-.499h2.75a.8.8 0 0 0 .789-.749.704.704 0 0 0-.71-.749h-1l.038-.749a.47.47 0 0 0-.474-.499h-.5a.533.533 0 0 0-.526.5l-.039.748z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.607 15.49c4.143 0 7.676-3.354 7.893-7.49S12.535.51 8.393.51.716 3.864.5 8s2.965 7.49 7.107 7.49M14 8c-.173 3.31-3 5.992-6.314 5.992S1.826 11.309 2 8c.173-3.31 3-5.992 6.314-5.992S14.174 4.691 14 8"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconPayment;
